import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";

const ADMIN_SYSTEM_MESSAGES_GET = "ADMIN_SYSTEM_MESSAGES_GET";
const ADMIN_SYSTEM_MESSAGE_SEND = "ADMIN_SYSTEM_MESSAGE_SEND";


export const getAdminSystemMessages = createAction(
  ADMIN_SYSTEM_MESSAGES_GET,
  async (params, callback) => {
    try {
      const response = await api.SystemMessage.getAdminMessages(params);
      callback && callback(response);
      return response;
    } catch (error) {
      callback && callback(null, error);
      throw error;
    }
  }
);

export const sendSystemMessage = createAction(
  ADMIN_SYSTEM_MESSAGE_SEND,
  async (payload, callback) => {
    try {
      const response = await api.SystemMessage.send(payload);
      callback && callback(true);
      return response;
    } catch (error) {
      callback && callback(false, error);
      throw error;
    }
  }
);

export const selectAdminSystemMessages = (state) =>
  state.admin.systemMessages.sentMessages;
const initialState = {
  sentMessages: [],
};

export default handleActions(
  {
    [ADMIN_SYSTEM_MESSAGES_GET]: (state, { payload }) => ({
      ...state,
      sentMessages: Array.isArray(payload) ? payload : [],
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageSystemMessagesPage/systemMessages.ducks.ts